/**
 * Baut die OrgAdmin-REST-Pfade für Device-Endpoints – gemeinsame Codebasis für den
 * Angular-`OrgAdminEndpointsService` (HttpClient) und den E2E-Device-Sweep (`fetch`).
 *
 * `userId` ist die MXID (`@user:domain`) und wird bewusst NICHT URL-kodiert: '@' und ':'
 * werden unkodiert im Pfad gesendet – so erwartet es das Backend. Ein `encodeURIComponent`
 * würde zu %40/%3A führen und brechen.
 */

/** Basis: `{regDienstUrl}/org-admin/v1/domains/{domain}/users/{userId}`. */
function userBase(regDienstUrl: string, domain: string, userId: string): string {
  return `${regDienstUrl}/org-admin/v1/domains/${domain}/users/${userId}`;
}

/** Geräteliste eines Users: `.../users/{userId}/devices`. */
export function userDevicesPath(regDienstUrl: string, domain: string, userId: string): string {
  return `${userBase(regDienstUrl, domain, userId)}/devices`;
}

/** Einzelnes Device eines Users: `.../users/{userId}/devices/{deviceId}`. */
export function userDevicePath(regDienstUrl: string, domain: string, userId: string, deviceId: string): string {
  return `${userDevicesPath(regDienstUrl, domain, userId)}/${deviceId}`;
}
